import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020classification/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};

interface IVoteListParam {
  page: number;
  search?: string;
  group?: number | string;
  work_type?: number | string;
}

export const getVoteList = (data: IVoteListParam) => {
  return http.get(`${baseUrl}vote-list`, {
    params: data,
  });
};

export const getNewsList = (page: number) => {
  return http.get(`${baseUrl}news-list`, {
    params: {
      page,
    },
  });
};

export const getRule = () => {
  return http.get(`${baseUrl}rules`);
};

export const getDetail = (id: any) => {
  return http.get(`${baseUrl}detail`, {
    params: {
      id,
    },
  });
};

export const getRankList = (data: IVoteListParam) => {
  return http.get(`${baseUrl}Rank`, {
    params: data,
  });
};

// 投票
interface IVoteOption {
  id: string | number;
  unionid: string;
}
export const vote = (data: IVoteOption) => {
  return http.post(`${baseUrl}vote`, qs.stringify(data));
};

// 获取openId
export const getOpenId = (code: any) => {
  return http.post(
    '/vote/public/controller.php?enews=classification',
    qs.stringify({
      code,
    }),
  );
};

// 获取jssdk
export const getJsSdk = (jssdkurl: any) => {
  return http.get('/vote/public/controller.php?enews=classificationjssdk', {
    params: {
      jssdkurl,
    },
  });
};
